import { useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { AppContext, EMPTY_OBJECT } from 'commons-ui';

import usePermission from '../../permission/usePermission';

const useSettingsActions = (makeActionHandler: any, makeActionList: any, containerParams: any = EMPTY_OBJECT) => {
	const history = useHistory();
	const location = useLocation();
	const { app, showAlert } = useContext(AppContext);
	const { hasPermission } = usePermission();
	const getActionHandler = (action: any, params = EMPTY_OBJECT) => {
		return makeActionHandler(action, {
			...containerParams,
			...params,
			location,
			history,
			isGold: app.isGold,
			appName: app.appName,
			showAlert
		});
	};
	const getActionList = (params = EMPTY_OBJECT) => {
		return makeActionList({
			...containerParams,
			...params,
			history,
			appName: app.appName,
			isGold: app.isGold,
			hasPermission
		});
	};

	return {
		getActionHandler,
		getActionList
	};
};

export default useSettingsActions;
